// DOM / header UI helpers.
// Moved from js/global.ts (originally js/main.js + js/Validation-file.js).
// global.ts re-exports these for back-compat with existing importers and its tests.

export function domReady(callback: () => void): void {
  if (["interactive", "complete"].indexOf(document.readyState) >= 0) {
    callback()
  } else {
    document.addEventListener("DOMContentLoaded", callback)
  }
}

export function toggleNav(
  allToggles: NodeListOf<Element>,
  nav: Element,
  navToggle: Element,
  closeToggle: Element,
): void {
  allToggles.forEach((toggle) => toggle.classList.toggle("hide"))
  nav.classList.toggle("open")
  navToggle.classList.toggle("open")
  closeToggle.classList.toggle("show")
}

export function toggleLang(
  allToggles: NodeListOf<Element>,
  langSwitcher: Element,
  langToggle: Element,
  closeToggle: Element,
): void {
  allToggles.forEach((toggle) => toggle.classList.toggle("hide"))
  langSwitcher.classList.toggle("open")
  langToggle.classList.toggle("open")
  closeToggle.classList.toggle("show")
}

export function toggleSearch(
  allToggles: NodeListOf<Element>,
  search: Element,
  searchToggle: Element,
  closeToggle: Element,
): void {
  allToggles.forEach((toggle) => toggle.classList.toggle("hide"))
  search.classList.toggle("open")
  searchToggle.classList.toggle("open")
  closeToggle.classList.toggle("show")
}

export function closeAll(allElements: NodeListOf<Element>, closeToggle: Element): void {
  allElements.forEach((element) => element.classList.remove("hide", "open"))
  closeToggle.classList.remove("show")
}

export function toggleDisabled(emailGlobalUnsub: HTMLInputElement): void {
  const emailSubItems = document.querySelectorAll("#email-prefs-form .item")
  emailSubItems.forEach((item) => {
    const input = item.querySelector("input") as HTMLInputElement | null
    if (emailGlobalUnsub.checked) {
      item.classList.add("disabled")
      input?.setAttribute("disabled", "disabled")
      if (input) input.checked = false
    } else {
      item.classList.remove("disabled")
      input?.removeAttribute("disabled")
    }
  })
}

export function insertAfter(newNode: Node, referenceNode: Node): void {
  referenceNode.parentNode?.insertBefore(newNode, referenceNode.nextSibling)
}
